import { useState, useEffect } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';
interface ExtraParams {
	name: any;
	value: any;
}
export const useDataTableDash = (
	url: string,
	extraParams: ExtraParams[] = [{ name: null, value: null }],
	refresh: number = 1
) => {
	const [isLoading, setIsLoading] = useState(true);
	const [response, setResponse] = useState<any>([]);
	const [totalDocs, setTotalDocs] = useState(0);
	const [perPage, setPerPage] = useState<any>(10);
	const [page, setPage] = useState(1);
	const [search, setSearch] = useState('');
	const [showHidden, setShowHidden] = useState(true);
	const [orderStatusIds, setOrderStatusIds] = useState<any>([]);
	const createUrl = (page: number) => {
		const urlWithParams = new URL(`${process.env.REACT_APP_API}/${url}`);
		urlWithParams.searchParams.set('page', `${page}`);
		urlWithParams.searchParams.set('limit', perPage);
		urlWithParams.searchParams.set('search', search);
		urlWithParams.searchParams.set('status', showHidden ? 'true' : '');
		orderStatusIds.map((id: any) => {
			urlWithParams.searchParams.append('orderStatusId[]', id);
		});
		if (extraParams && extraParams.length > 0) {
			extraParams.forEach((param: ExtraParams) => {
				if (param.value) {
					if (Array.isArray(param.value)) {
						param.value.forEach(item => {
							urlWithParams.searchParams.append(`${param.name}[]`, item);
						});
					} else {
						urlWithParams.searchParams.set(param.name, param.value);
					}
				}
			});
		}
		return urlWithParams;
	};
	const fetchData = async (page: number) => {
		try {
			setIsLoading(true);
			let urlParams = createUrl(page).toString();
			let response = await api.get(urlParams);
			let data = response.data.docs.map((doc: any) => {
				return {
					...doc,
					id: doc._id,
				};
			});
			setResponse(data);
			setTotalDocs(response.data.totalDocs);
			setIsLoading(false);
		} catch (err) {
			toast.error('Error al cargar los datos');
		}
	};
	const handlePageChange = (page: number) => {
		setPage(page);
		fetchData(page);
	};
	const handlePerRowsChange = async (newPerPage: number, page: number) => {
		try {
			setIsLoading(true);
			let urlParams = createUrl(page).toString();
			let response = await api.get(urlParams);
			setResponse(response.data.docs);
			setPerPage(newPerPage);
			setIsLoading(false);
		} catch (err) {
			toast.error('Error al cargar los datos');
		}
	};
	useEffect(() => {
		fetchData(page);
	}, [
		url,
		search,
		showHidden,
		perPage,
		refresh,
		orderStatusIds,
		...extraParams.map(param => param.value),
	]);
	return {
		isLoading,
		response,
		setResponse,
		totalDocs,
		perPage,
		page,
		handlePageChange,
		handlePerRowsChange,
		search,
		setSearch,
		showHidden,
		setShowHidden,
		fetchData,
		orderStatusIds,
		setOrderStatusIds,
	};
};
